<a class="branding" routerLink="/">
  @if (collapsed) {
    @if (appContext.communityClubLogoUrl) {
      <img
        alt="Club logo"
        [src]="appContext.communityClubLogoUrl"
        class="w-12 h-12 rounded-full object-contain shadow-sm border border-ttg-black-200 bg-white"
        alt="Logo" />
    } @else {
      <img
        ngSrc="TTG-Logo-Kompakt-Neon.svg"
        class="branding-logo"
        alt="logo"
        width="32"
        height="32" />
    }
  }
  @if (showName && !collapsed) {
    @if (appContext.communityClubLogoUrl) {
      <img
        alt="Club logo"
        [src]="appContext.communityClubLogoUrl"
        class="w-12 h-12 rounded-full object-contain shadow-sm border border-ttg-black-200 bg-white"
        alt="Logo" />
    } @else {
      <img
        class="branding-name"
        [ngSrc]="wordLogo"
        alt="Word logo"
        height="167"
        width="999" />
    }
  }
</a>
